export default {"src":"/_next/static/media/time_s.1adb4ccb.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};